import { Component, OnInit, Input } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { FormsFns } from '@core/models/forms-fns.model';
import { BaseComponent } from '@shared/components/base/base.component';
import { dateBuilder, maxExpiryDate } from '@core/models/date.model';
import { AddressDataService } from '../services/address-data.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClientAddressModel } from '@api/models';
import { AddressLabelsType } from '../models/address-form.model';
import { TranslocoService } from '@ngneat/transloco';
import { Globals } from 'src/app/globals';

export interface AddressFormConfig {
  showEffectiveDate?: boolean;
  showExpiryDate?: boolean;
  showPrimaryField?: boolean;
  showAddressType?: boolean;
}

@Component({
  selector: 'cf2-address-form',
  templateUrl: './address-form.component.html',
})
export class AddressFormComponent extends BaseComponent implements OnInit {
  @Input() set isDisabled(bool: boolean) {
    if (bool) {
      this.fields.fg.disable(FormsFns.formUpdateOpts);
      this.fields.fg.updateValueAndValidity(FormsFns.formUpdateOpts);
    }
  }
  isInit = false;
  @Input() fields: {
    fg: UntypedFormGroup;
    labels: AddressLabelsType;
    disabled: AddressLabelsType;
    required: AddressLabelsType;
  };

  @Input() config: AddressFormConfig = {
    showEffectiveDate: true,
    showExpiryDate: true,
    showPrimaryField: true,
    showAddressType: true,
  };

  @Input() showPrimaryCategoryField = false;

  get isReadOnly() {
    return this.dataSvc.getIsReadOnly();
  }

  addressTypes$ = this.dataSvc.addressTypes$;
  provinceTypes$ = this.dataSvc.provinceTypes$;

  labels: any;
  required: any;
  disabled: any;
  fg: UntypedFormGroup;
  getFc: (formKey: string) => AbstractControl;
  public minDate = new Date(dateBuilder()[0] - 2, dateBuilder()[1], dateBuilder()[2] - 1, 0, 0, 0, 0);

  /* the maximum allowed date for the document  */
  public maxDate = maxExpiryDate();

  constructor(
    private dataSvc: AddressDataService, 
    private service: TranslocoService,
    private globals: Globals
  ) {
    super();
  }

  primaryAddressChanged($event) {
    console.log($event);
  }

  ngOnInit() {
    if (!this.fields) {
      throw new Error('no fields set in <cf2-address-form>, you have to initalize address form');
    }

    const { fg, labels, required, disabled } = this.fields;

    this.getFc = FormsFns.getFc(fg);
    const { provinceCode } = fg.controls;
    
    if (['wc'].includes(this.globals.catchment)) {
      provinceCode.patchValue(provinceCode.value ? provinceCode.value : 'AB', FormsFns.formUpdateOpts);
    } else {
      provinceCode.patchValue(provinceCode.value ? provinceCode.value : 'ON', FormsFns.formUpdateOpts);
    }
    
    this.fg = fg;
    this.labels = labels;
    this.required = required;
    this.disabled = disabled;
    setTimeout(() => {
      this.isInit = true;
    }, 100);
  }
}
